import { render, staticRenderFns } from "./NewSaleTeam.vue?vue&type=template&id=5fe24c1c"
import script from "./NewSaleTeam.vue?vue&type=script&lang=js"
export * from "./NewSaleTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports